import { Socket } from 'socket.io-client';
import { SocketMessage } from '../types';
import {
  AssistantChatMessagePayload,
  assistantMessageHandler,
} from './assistantChatMessageHandler';
import { SocketEventType } from '../types';
import { chatErrorHandler, ChatErrorPayload } from './chatErrorHandler';
import { messageStatusHandler, MessageStatusPayload } from './messageStatusHandler';
import { thinkingUpdateHandler, ThinkingUpdatePayload } from './thinkingUpdateHandler';
import { summaryUpdateHandler, SummaryUpdatePayload } from './summaryUpdateHandler';

export const setupHandlers = (socket: Socket) => {
  // Remove existing handlers to avoid duplicates
  socket.off(SocketEventType.AssistantChatMessage);
  socket.off(SocketEventType.ChatError);
  socket.off(SocketEventType.MessageStatus);
  socket.off(SocketEventType.ThinkingUpdate);
  socket.off(SocketEventType.SummaryUpdate);

  // Assistant message handler
  socket.on(
    SocketEventType.AssistantChatMessage,
    (message: SocketMessage<AssistantChatMessagePayload>) => {
      assistantMessageHandler(message);
    },
  );

  // Chat error handler
  socket.on(SocketEventType.ChatError, (message: SocketMessage<ChatErrorPayload>) => {
    chatErrorHandler(message);
  });

  // Message status handler
  socket.on(SocketEventType.MessageStatus, (message: SocketMessage<MessageStatusPayload>) => {
    messageStatusHandler(message);
  });

  // Thinking update handler
  socket.on(SocketEventType.ThinkingUpdate, (message: SocketMessage<ThinkingUpdatePayload>) => {
    thinkingUpdateHandler(message);
  });

  // Summary update handler
  socket.on(SocketEventType.SummaryUpdate, (message: SocketMessage<SummaryUpdatePayload>) => {
    summaryUpdateHandler(message);
  });
};
